import numberCurrency from './numberCurrency';

export function formatFidelityType(value, type) {
  if (type === 'cb' || !type) {
    return numberCurrency(value, true, 2);
  }
  if (type === 'pt') {
    // Para pontos, formatar permitindo decimais mas sem forçar 2 casas decimais
    const numValue = Number(value);
    if (Number.isFinite(numValue)) {
      // Se o valor tem decimais, mostrar até 2 casas, senão mostrar sem decimais
      const hasDecimals = numValue % 1 !== 0;
      if (hasDecimals) {
        return new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          maximumFractionDigits: 2,
          minimumFractionDigits: 0
        }).format(numValue) + ' pts';
      } else {
        return new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0
        }).format(numValue) + ' pts';
      }
    }
    return '0 pts';
  }
  throw new Error(`Tipo desconhecido: ${type}`);
}
